module.exports = __webpack_public_path__ + "media/images/levelup_bg-c26d36ea271d0842c71b5c526265c395.png";